import React from 'react';

const HealthLoopLogo = ({ size = 'md', showText = true, className = '' }) => {
  const sizes = {
    sm: { logo: 'h-16 w-16', text: 'text-2xl' },
    md: { logo: 'h-20 w-20', text: 'text-3xl' },
    lg: { logo: 'h-28 w-28', text: 'text-5xl' },
    xl: { logo: 'h-36 w-36', text: 'text-6xl' }
  };

  const sizeClasses = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src="/assets/healthloop-logo.png" 
        alt="HealthLoop Logo" 
        className={`${sizeClasses.logo} object-contain`}
      />
      {showText && (
        <div className="flex flex-col">
          <span className={`${sizeClasses.text} font-bold text-healthloop-navy-900 leading-tight tracking-tight`}>
            HEALTH LOOP
          </span>
          <span className="text-xs text-gray-600 font-medium -mt-1">
            Preventive Health Platform
          </span>
        </div>
      )}
    </div>
  );
};

export default HealthLoopLogo;
